import { useAppSelector } from '../redux/hooks'
const AccountRejected = () => {
    const branding = useAppSelector((state) => state.branding)
    const companyIcon = branding.company_icon
    return (
        <div className="min-h-screen bg-gray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <img
                    className="mx-auto h-12 w-auto"
                    src={companyIcon || ''}
                    alt="Logo"
                />
                <h2 className="mt-6 text-center text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                    Application Declined
                </h2>
                <p className="mt-4 text-center text-lg leading-8 text-gray-600">
                    We're sorry, but your application has been declined. We
                    appreciate your interest and encourage you to apply again in
                    the future.
                </p>
            </div>
        </div>
    )
}

export default AccountRejected
